import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import MainContent from './MainContent'
import { Helmet } from 'react-helmet'

const PaymentTerm = () => {
  
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
      <Helmet>
				<title>Payment Term List</title>
			</Helmet>
    <Header />
    <MainContent />
    {/* <Footer /> */}
    </div>
  )
}

export default PaymentTerm